<div class="d-flex justify-content-between align-items-center ml-4 mt-4">
    <h4 class="card-label mb-0" (click)="openModalAddProcedure()">Estimates</h4>
    <div class="mr-2">
        <!-- <button type="button" class="btn btn-outline-secondary" (click)="petEstimatesListBtn()">{{petService.pet.pet_name}}'s Estimates</button>
        <button type="button" class="btn btn-outline-secondary" (click)="genericEstimatesListBtn()">Generic Estimates</button>  -->
        <button type="button" class="btn btn-outline-secondary mr-2" (click)="estimatesListBtn()"> 
            <i class="las la-clipboard-list"></i> Premade Estimates
        </button>
        <button class="btn btn-success" (click)="openApprovalModal()"
            [disabled]="!petService.pet_estimate.estimate_def || petService.pet_estimate.estimate_def.length === 0 || getTotalCost() === 0">
            <i class="las la-signature"></i> Approve & Sign
        </button>
    </div>
</div>

<div class="card-body card-scroll h-500px p-1 pt-7"> 
    <form novalidate (ngSubmit)="onStatInput()" #formAddProcedures="ngForm">
        <div class="table-responsive"> 
            <table class="table align-middle table-bordered my-0">
                <thead> 
                    <tr class="table-secondary fw-bold fs-6 text-gray-800" style="border: none !important; ">

                        <th colspan="2" style="vertical-align: initial;">
                            <div class="d-inline-grid align-items-center" style="width: 100%;">
                                <div class="d-flex"> 
                                    <input type="text" autocomplete="off" class="form-control form-control-sm mr-2" required
                                        name="_code_name" [(ngModel)]="filterText" (keydown)="search($event)"
                                        style="flex: 3;" > 
                                </div>
                                <div class="list-group button-container" style="max-height: 200px;overflow-y: auto;"
                                    *ngIf="buscador_activo">
                                    <button type="button" class="list-group-item list-group-item-action list-group-item-sm"
                                        *ngFor="let item of suggestedWordsArray"
                                        (click)="select(item); statusSelect.click();">
                                        {{ item.code_name + " " + item.procedure_desc }}
                                    </button>
                                </div> 
                            </div>
                        </th>

                        <th style="vertical-align: initial;">
                            <div style="max-width:200px ;">
                                <select class="form-control form-select-sm" name="_Status" id="_Status"
                                    [(ngModel)]="txtchar" required #statusSelect placeholder="Select a Status"
                                    (change)="onStatusSelected($event.target, formAddProcedures)">
                                    <option value="" selected>Select a Status</option>
                                    <option value="R">R - Request</option>
                                    <option value="D">D - Done</option>
                                    <option value="F">F - Refund</option>
                                    <option value="W">W - Working</option>
                                    <option value="C">C - Client request</option>
                                    <option value="S">S - Suggested</option>
                                    <option value="P">P - Pharm Label</option>
                                    <option value="*">* - Brief History</option>
                                </select>
                            </div>

                        </th>
                        <th style="vertical-align: initial;"> 
                            <ng-container *ngIf="this.petService.pet_estimate.estimate_def.length > 0">
                                <div class="d-flex flex-row align-items-center">
                                    <button
                                        type="button"
                                        class="btn btn-success btn-sm mr-2 d-inline-flex align-items-center"
                                        (click)="redefineItems()"
                                    >
                                        <i class="las la-sync-alt mr-1"></i>
                                        Redefine
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-warning btn-sm d-inline-flex align-items-center"
                                        (click)="clearItems()"
                                    >
                                        <i class="las la-eraser mr-1"></i>
                                        Clear
                                    </button>
                                </div>
                            </ng-container> 
                        </th>
                        <th style="vertical-align: initial;"> 
                            <ng-container *ngIf="this.petService.pet_estimate.estimate_sequence === 0 && this.petService.pet_estimate.estimate_def.length > 0"> 
                                <div class="dropdown">
                                    <button class="btn btn-primary btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                                        <i class="las la-save"></i> Save as New
                                    </button>
                                    <div class="dropdown-menu">
                                      <a class="dropdown-item" (click)="modalSaveAsNew('generic')">Generic Estimate</a>
                                      <a class="dropdown-item" (click)="modalSaveAsNew('pet')">Pet Estimate</a> 
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="this.petService.pet_estimate.estimate_sequence !== 0 && this.petService.pet_estimate.estimate_def.length > 0">
                                <button class="btn btn-primary btn-sm" (click)="save()"><i class="las la-plus"></i> Save Changes</button>
                            </ng-container>
                        </th>  
                    </tr>
                    <tr class="fw-bold fs-6 text-gray-800 table-dark">
                        <th width="5%">

                        </th>
                        <th>
                            Procedure
                        </th>
                        <th width="40%">
                            Description
                        </th>
                        <th width="15%">
                            Category
                        </th>
                        <th width="15%">
                            Price
                        </th>
                        
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let item of this.petService.pet_estimate.estimate_def" >
                        <tr *ngIf="item.link_count !== 0">
                            <td> {{ item.link_count }}</td>
                            <td>
                                <div class="d-inline-flex align-items-center" style="width: 100%;">
                                    <button type="button" class="btn btn-secondary col-8"
                                        style="padding: 0.25rem 1rem !important;" >
                                        {{ item.code_name }}
                                    </button> 
                                    <div class="dropdown col-4">
                                        <button class="btn btn-secondary mr-1 dropdown-toggle" type="button"
                                            data-toggle="dropdown" style="padding: 0.25rem 1rem !important;" 
                                            aria-haspopup="true" aria-expanded="false">
                                            {{item.status}}
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <a class="dropdown-item"  
                                                *ngFor="let button of getStatusOption('R')">
                                                {{ button.desc }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>{{ item.procedure_desc }}</td>
                            <td>{{ item.code_category}}</td>
                            <td>{{ item.link_cost | currency }}</td> 
                        </tr>
                    </ng-container>
                    
                    <!-- Total Row -->
                    <tr class="table-warning fw-bold" *ngIf="petService.pet_estimate.estimate_def && petService.pet_estimate.estimate_def.length > 0">
                        <td colspan="4" class="text-end">
                            <strong>Total:</strong>
                        </td>
                        <td>
                            <strong>{{ getTotalCost() | currency }}</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
</div>

<!-- Combined Modal for displaying estimates with tabs -->
<div class="modal fade" id="modalEstimates" tabindex="-1" role="dialog" aria-labelledby="modalEstimatesLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalEstimatesLabel">Premade Estimates</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <!-- Bootstrap Tabs -->
                <ul class="nav nav-tabs" id="estimatesTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <a class="nav-link active" id="pet-estimates-tab" data-toggle="tab" href="#pet-estimates" role="tab" aria-controls="pet-estimates" aria-selected="true">
                            <i class="fas fa-paw mr-2"></i> Pet's Estimates
                        </a>
                    </li>
                    <li class="nav-item" role="presentation">
                        <a class="nav-link" id="generic-estimates-tab" data-toggle="tab" href="#generic-estimates" role="tab" aria-controls="generic-estimates" aria-selected="false">
                            <i class="fas fa-clipboard-list mr-2"></i> Generic Estimates
                        </a>
                    </li>
                </ul>

                <!-- Tab Content -->
                <div class="tab-content mt-3" id="estimatesTabContent">
                    <!-- Pet's Estimates Tab -->
                    <div class="tab-pane fade show active" id="pet-estimates" role="tabpanel" aria-labelledby="pet-estimates-tab">
                        <div class="table-responsive">
                            <p-table 
                                [value]="petService.pet_estimates" 
                                [paginator]="true"
                                [rows]="10"   
                                class="table table-bordered">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th scope="col">Estimate Name</th>
                                        <th scope="col">Date Added</th>
                                        <th scope="col">Total Charge</th> 
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item> 
                                    <tr (click)="openEstimate(item)">
                                        <td>{{item.estimate_name}}</td>
                                        <td>{{item.date_added}}</td>
                                        <td>${{item._total_charge}}</td>  
                                    </tr> 
                                </ng-template>
                            </p-table>
                        </div>
                    </div>

                    <!-- Generic Estimates Tab -->
                    <div class="tab-pane fade" id="generic-estimates" role="tabpanel" aria-labelledby="generic-estimates-tab">
                        <div class="table-responsive">
                            <p-table 
                                [value]="petService.pet_generic_estimates" 
                                [paginator]="true"
                                [rows]="10"   
                                class="table table-bordered">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th scope="col">Estimate Name</th>
                                        <th scope="col">Date Added</th>
                                        <th scope="col">Total Charge</th> 
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item> 
                                    <tr (click)="openEstimate(item)">
                                        <td>{{item.estimate_name}}</td>
                                        <td>{{item.date_added}}</td>
                                        <td>${{item._total_charge}}</td>  
                                    </tr> 
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- Estimate Approval Modal -->
<div class="modal fade" id="modalEstimateApproval" tabindex="-1" role="dialog" aria-labelledby="modalEstimateApprovalLabel" aria-hidden="true">
    <div class="modal-dialog estimate-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div>
                    <h5 class="modal-title mb-0" id="modalEstimateApprovalLabel">ESTIMATE APP.</h5>
                    <small class="text-muted">Date {{ now | date:'M/d/y h:mm a' }}</small>
                </div>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="paper p-4">
                <div class="mb-3">
                    <div class="d-flex justify-content-between">
                        <div>
                            <div><strong>Client Name:</strong> {{ clientService.client.first_name }} {{ clientService.client.last_name }}</div>
                            <div><strong>Client No:</strong> {{ clientService.client.client_no }}</div>
                            <div><strong>Address:</strong> {{ clientService.client.address }}</div>
                            <div><strong>Contact No.:</strong> {{ clientService.client.home_phone }}</div>
                        </div>
                        <div class="text-right">
                            <div><strong>Pet:</strong> {{ petService.pet.pet_name }}</div>
                        </div>
                    </div>
                    <hr/>
                </div>
                <div>
                    <div class="row">
                        <div class="table-responsive" style="max-height: 400px; overflow:auto;">
                            <table class="table table-sm table-bordered mb-0">
                                <thead class="table-light">
                                    <tr>
                                        <th>Category</th>
                                        <th>Procedure</th>
                                        <th class="text-center">Quantity</th>
                                        <th>Description</th>
                                        <th class="text-right">Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of petService.pet_estimate.estimate_def" [ngClass]="{'d-none': item.link_count === 0}">
                                        <td>{{ item.code_category }}</td>
                                        <td>{{ item.code_name }}</td>
                                        <td class="text-center">{{ item.link_count }}</td>
                                        <td>{{ item.procedure_desc }}</td>
                                        <td class="text-right">{{ item.link_cost | currency }}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="4" class="text-right"><strong>Total Quantity</strong></td>
                                        <td class="text-right">{{ getTotalQuantity() }}</td>
                                    </tr>
                                    <tr class="table-warning">
                                        <td colspan="4" class="text-right"><strong>Total Cost</strong></td>
                                        <td class="text-right"><strong>{{ getTotalCost() | currency }}</strong></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div class="row mt-9">  
                        <div class="col-6 signature-container d-flex justify-content-center align-items-center">
                            <div class="text-center w-100">
                                <signature-pad #signaturePadClient [options]="signaturePadOptions"></signature-pad>
                                <p class="mt-2">Client Signature</p>
                            </div>
                        </div>
                        <div class="col-6 signature-container d-flex justify-content-center align-items-center">
                            <div class="text-center w-100">
                                <signature-pad #signaturePadAttending [options]="signaturePadOptions"></signature-pad>
                                <p class="mt-2">Attending Signature</p>
                            </div>
                        </div> 
                    </div>
                </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> 
                <button type="button" class="btn btn-primary" (click)="print()"><i class="las la-print"></i> Print</button>
            </div>
        </div>
    </div>
</div>

<!-- Save As New modal -->
<div class="modal fade" id="modalSaveAsNew" tabindex="-1" role="dialog" aria-labelledby="modalSaveAsNewLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalSaveAsNewLabel">
                    {{ saveAsType === 'generic' ? 'Save as Generic Estimate' : 'Save as Pet Estimate' }}
                </h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <label for="saveAsEstimateName">Estimate Name</label>
                    <input
                        id="saveAsEstimateName"
                        type="text"
                        class="form-control"
                        [(ngModel)]="EstimateName"
                    />
                </div>
                <div class="form-group">
                    <label for="saveAsEstimateRemarks">Remarks</label>
                    <textarea
                        id="saveAsEstimateRemarks"
                        class="form-control"
                        rows="3"
                        [(ngModel)]="EstimateRemarks"
                    ></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <ng-container *ngIf="saveAsType === 'generic'">
                    <button type="button" class="btn btn-primary" (click)="saveasGenericEstimate()">Save Generic Estimate</button>
                </ng-container>
                <ng-container *ngIf="saveAsType === 'pet'">
                    <button type="button" class="btn btn-primary" (click)="saveasPetEstimate()">Save Pet Estimate</button>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<style>
.break {
    flex-basis: 100%;
    height: 0;
}

.ng-autocomplete {
     width: 600px;
    width: auto !important; 
    display: flex !important;
}

.table-dark td, .table-dark th {
    background-color: #444c53;
}   

/* Portrait paper feel */
.estimate-dialog {
    max-width: 900px; /* ~A4 width at typical zoom */
} 
</style>
 



<!-- <div class="card card-custom gutter-b card-fit" data-card="true" id="kt_card_1">
    <div class="card-header">
        <div class="card-title"> 
        </div>
        <div class="card-toolbar">

            <button type="button" class="btn btn-sm  btn-secondary mr-2 font-weight-bold">
                <i class="fas fa-filter icon-sm"></i>Filter
            </button>

            <button type="button" class="btn btn-sm btn-primary font-weight-bold" (click)="add()"> 
                <i class="fas fa-plus icon-sm"></i>Add {{(tab_no != 1)? 'Generic':''}} Estimate
            </button>
        </div>
    </div>
    <div class="card-body  mt-0 py-0 px-5">
        <span *ngIf="petService.pet_estimates.length === 0">No information available</span>
        <div class="table-responsive h-500px">
            <table class="table">
                <thead>
                    <tr>
                        <th class="p-0 min-w-150px"></th>
                        <th class="p-0 min-w-120px"></th>
                        <th class="p-0 min-w-100px"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of tab_no == 0 ? petService.pet_generic_estimates : petService.pet_estimates">

                        <td class="pl-0">
                            <span class="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg"
                                (click)="edit(item)">
                                {{ item.estimate_name }}
                            </span>
                            <p>{{ item.estimate_note }}</p>
                        </td>

                        <td class="text-right">
                            <span class="text-muted font-weight-bold">{{ item.date_added }}</span>
                        </td>
                        <td class="text-right pr-0">
                            <div class="btn-group">
                                <button type="button" class="btn btn-icon btn-secondary btn-sm m-1" (click)="edit(item)">
                                    <i class="las la-sms"></i>
                                </button>
                                <button type="button" class="btn btn-icon btn-secondary btn-sm m-1" (click)="edit(item)">
                                    <i class="la la-pen"></i>
                                </button>
                                <button type="button" class="btn btn-icon btn-secondary btn-sm btn-hover-danger m-1" (click)="delete(item)">
                                    <i class="la la-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>
    </div>
</div> -->